import axios from 'axios'
import { AppDispatch } from '../store'
import { companies, companiesFailure, companiesRequest } from '../companiesSlice'
import { API_URL } from '../../const'
import { getAccessToken } from '../../auth/accessToken'

export const getCompanies = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(companiesRequest())
    const accessToken = await getAccessToken()
    const { data: companiesData } = await axios.get(`${API_URL}/Integration/companies`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'X-MONDRA-APP': 'DataPlatform',
      },
    })
    sessionStorage.setItem('companies', companiesData.map(company => company.id).toString())
    dispatch(companies(companiesData))
  } catch (error: any) {
    dispatch(companiesFailure(error.message))
  }
}
